import { safeSessionStorage } from './safeStorage';

/** Session key shared with claw game chip + native AppsFlyer attribution promo UI. */
export const CLAW_PROMO_CODE_SESSION_KEY = 'claw_promo_code';

export const NATIVE_PROMO_CODE_EVENT = 'hzc_native_promo_code';

/** Push promo code into the same floating chip as the claw game (session + custom event). */
export function applyNativeAttributionPromoCode(code: string | null | undefined): void {
  const c = String(code || '').trim();
  if (typeof window === 'undefined' || !c) return;
  safeSessionStorage.setItem(CLAW_PROMO_CODE_SESSION_KEY, c);
  try {
    window.dispatchEvent(new CustomEvent(NATIVE_PROMO_CODE_EVENT, { detail: { code: c } }));
  } catch {
    // ignore
  }
}
